module.exports = __webpack_public_path__ + "static/media/Score-Low.fbb7c129.svg";